import React from "react";
import { Stack, Typography } from "@mui/material";

export const HighlightedDetailField = ({
  label,
  spanishLabel,
  value,
  endAdornment,
  ...rest
}) => (
  <Stack className="HubHighlitedDetailField" {...rest} gap="5px">
    <Stack direction="row" gap="5px">
      {label && <Typography variant="boldCaptionMainL">{label}</Typography>}
      {spanishLabel && (
        <Typography variant="boldCaption">({spanishLabel})</Typography>
      )}
    </Stack>
    <Stack
      sx={{
        minHeight: "30px",
        height: "fit-content",
        backgroundColor: "hubColors.mainFocusLighter2",
        padding: "5px 10px",
        borderRadius: "5px",
        flexDirection: "row",
        justifyContent: endAdornment ? "space-between" : "start",
        alignItems: "center",
      }}
    >
      <Typography
        variant="caption"
        className="HubHighlitedDetailField-caption"
        sx={{
          fontWeight: 600,
          fontSize: 12,
        }}
      >
        {value}
      </Typography>
      {endAdornment && (
        <Typography
          variant="inputAdornment"
          sx={{
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          {endAdornment}
        </Typography>
      )}
    </Stack>
  </Stack>
);

export default HighlightedDetailField;
